import script from "./ClientOnboardingOverlayNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientOnboardingOverlayNew.vue?vue&type=script&setup=true&lang=js"

import "./ClientOnboardingOverlayNew.vue?vue&type=style&index=0&id=0f736328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f736328"]])

export default __exports__